export default {

  eventContacts: ((state, getters, rootState) => (eventId) => {
    return Object.values(rootState.entities.contacts).filter(item => item.event === eventId);
  }),

  contactDetails: ((state, getters, rootState) => (contactId, bucket = 'entities') => {
    if (!rootState[bucket].contacts[contactId]) {
      return [];
    }
    return rootState[bucket].contacts[contactId].contactDetails.map(id => rootState.entities.contactDetails[id])
  }),

};


// WEBPACK FOOTER //
// ./src/store/contacts/getters.js